import { KeyValue } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { InfoTableConfig } from '../shared.interface';
@Component({
    selector: 'app-info-table-multirow',
    templateUrl: './info-table-multirow.component.html',
    styleUrls: ['./info-table-multirow.component.scss'],
})
export class InfoTableMultirowComponent implements OnInit {
    @Input() tableData: InfoTableConfig;

    originalOrder = (
        a: KeyValue<number, string>,
        b: KeyValue<number, string>
    ): number => {
        return 0;
    };

    constructor() {}

    ngOnInit(): void {}
}
